import { Obstruction } from '../obstruction.class';
import { Vertex3 } from '../../../spatial-classes';

/**
 * Calculates the center position of an island relative to the default island
 * The center represents the spatial delta from the default island (absolute center of blueprint)
 * Center is calculated based on connections to the source island, taking into account
 * angles, offsets, padding, and alignment
 * @param island The island to calculate center for
 * @returns Vertex3 representing the center position relative to the default island
 */
export const getCenterCfn = (island: Obstruction): Vertex3 => {
	const centerPos = new Vertex3();

	// short circuit for default island center is 0,0,0
	if (island.isDefaultIsland) return centerPos;

	// Find the source connection for this island
	const sourceConnections = island.connections.getSourceConnections();

	// always use the source connection to move source island
	if (!sourceConnections || sourceConnections.length === 0) return centerPos;

	// get the source connection
	const [connection] = sourceConnections;
	const { sourceIsland, targetIsland } = connection;

	// connection is not linked properly, return 0,0,0
	if (targetIsland === null || sourceIsland === null) {
		// console.warn('getCenterCfn: Connection is not linked properly', {
		// 	sourceIsland: sourceIsland?.id,
		// 	targetIsland: targetIsland?.id,
		// 	sourcePanelId: connection.sourcePanelId,
		// 	targetIslandId: connection.targetIslandId
		// });
		return centerPos;
	}

	const sp = connection.getSourcePoint().rotateAxis(new Vertex3(), sourceIsland.axis.y, 'y');
	const tp = connection.getTargetPoint().rotateAxis(new Vertex3(), targetIsland.axis.y, 'y');

	// source and target points are already rotated and are relative to their respective island center
	// const sp = connection.getSourcePoint();
	// const tp = connection.getTargetPoint();

	const padding = new Vertex3({ dataIn: { z: connection.padding }});
	const paddingAngle = sourceIsland.axis.y - connection.sourcePanel.getOriginAngle();
	if (connection.sourcePanel)	padding.rotateAxis(new Vertex3(), paddingAngle, 'y');

	const offset = new Vertex3({ dataIn: { z: (connection.sourcePanel?.isLeftPanel ? 1 : -1) * (connection.offset) }})
	if (connection.sourcePanel)	offset.rotateAxis(new Vertex3(), sourceIsland.axis.y - connection.sourcePanel.getOriginAngle() + 90, 'y');

	// console.log('getCenterCfn', {
	// 	axis: sourceIsland.axis.y,
	// 	targetCenter: targetIsland.center.serialize(),
	// 	sp: sp.serialize(),
	// 	tp: tp.serialize(),
	// 	padding: padding.serialize(),
	// 	offset: offset.serialize()
	// });

	// centerPos starts at 0,0,0
	// console.log('test-center-obs', targetIsland.center, tp, sp, padding, offset);
	centerPos
		// target islands center which is relative to the default island (0,0,0)
		.add(targetIsland.center)
		// targets corner point relative to the targets center
		.add(tp)
		// source islands corner point relative to the source islands center (0,0,0)
		.subtract(sp)
		// substract the requested padding between source and target islands
		.subtract(padding)
		// substract the requested offset between source and target islands
		.subtract(offset);

	// console.log('getCenterCfn', {
	// 	targetCenter: targetIsland.center.serialize(),
	// 	sp: sp.serialize(),
	// 	tp: tp.serialize(),
	// 	padding: padding.serialize(),
	// 	offset: offset.serialize(),
	// 	centerPos: centerPos.serialize()
	// });

	// recursively move all connections
	// sourceIsland.connections.filter((c) => !c.isSource).forEach((c) => {
	// 	moveSourceIslandCfn(c);
	// });

	// console.log('moveSourceIslandCfn', {
	// 	sourceBase: sourceIsland.position.origin.y + (sourceIsland.size.height / 2),
	// 	targetBase: targetIsland.position.origin.y + (targetIsland.size.height / 2)
	// });
	// console.log('!!!!', paddingDelta, { targetDelta, before: sourceIslandCenter, after: sourceIsland.position.centerpoint.serialize() });
	return centerPos;
};
